import React from 'react';
import LinkTree from '../components/LinkTree';

const LinkTreePage = () => {
  return <LinkTree />;
};

export default LinkTreePage;